import { useState } from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { SEO } from "@/components/SEO";
import { FadeIn } from "@/components/FadeIn";
import { RevealHeading } from "@/components/RevealHeading";
import { SectionLabel } from "@/components/SectionLabel";
import { caseStudies, workFilters } from "@/data/caseStudies";
import { images } from "@/data/images";

export default function Work() {
  const [filter, setFilter] = useState("ALL");
  const filtered = filter === "ALL" ? caseStudies : caseStudies.filter((c) => c.category === filter);

  return (
    <div data-testid="work-page">
      <SEO
        title="Work"
        description="A portfolio architecture for DULORME LABS branding, marketing, web and growth case studies."
        path="/work"
      />

      <section className="pt-40 pb-16 border-b border-white/10">
        <div className="container-custom">
          <SectionLabel>Work / Results</SectionLabel>
          <RevealHeading
            tag="h1"
            lines={["PROOF LIVES IN", "THE RESULTS."]}
            className="font-display font-black text-4xl sm:text-5xl lg:text-6xl leading-[1.0] tracking-tight text-white max-w-3xl"
          />

          <FadeIn delay={0.3} className="mt-12 flex flex-wrap gap-3">
            {workFilters.map((f) => (
              <button
                key={f}
                onClick={() => setFilter(f)}
                data-testid={`work-filter-${f.toLowerCase()}`}
                className={`text-xs font-bold tracking-widest uppercase px-5 py-3 border transition-colors duration-300 ${
                  filter === f ? "bg-white text-black border-white" : "border-white/20 text-zinc-400 hover:text-white hover:border-white/40"
                }`}
              >
                {f}
              </button>
            ))}
          </FadeIn>
        </div>
      </section>

      <section className="py-24">
        <div className="container-custom">
          {filtered.length === 0 ? (
            <FadeIn data-testid="work-empty-state" className="text-center py-10">
              <img src={images.laptopAnalytics} alt="Analytics dashboard placeholder" className="w-full max-w-2xl mx-auto aspect-video object-cover mb-12 opacity-70" />
              <p className="font-display text-2xl md:text-3xl text-white/70 font-light mb-4">
                Real case studies are on the way.
              </p>
              <p className="text-zinc-500 max-w-md mx-auto mb-10">
                This page is structured to showcase Company, Industry, Problem, Strategy, Execution and Results once real projects are ready to be featured.
              </p>
              <Link
                to="/contact"
                data-testid="work-empty-cta-link"
                className="group inline-flex items-center gap-2 border border-white/20 text-white text-xs font-bold tracking-widest uppercase px-8 py-4 hover:bg-white/10 transition-colors duration-300"
              >
                Start Your Project
                <ArrowRight size={14} className="transition-transform duration-300 group-hover:translate-x-1" />
              </Link>
            </FadeIn>
          ) : (
            <div className="grid md:grid-cols-2 gap-px bg-white/10">
              {filtered.map((cs) => (
                <div key={cs.client} className="bg-[#050505] p-10">
                  <p className="text-xs uppercase tracking-widest text-violet-400 mb-2">{cs.industry}</p>
                  <h3 className="font-display text-2xl font-bold text-white">{cs.client}</h3>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>
    </div>
  );
}
